export const setCredentials = credentials => {
  if (credentials.token) {
    localStorage.setItem('token', credentials.token);
    localStorage.setItem('firstName', credentials.firstName);
    localStorage.setItem('lastName', credentials.lastName);
    localStorage.setItem('accounts',  JSON.stringify(credentials.accounts));
    localStorage.setItem('currentAccountIndex',  credentials.currentAccountIndex);
    localStorage.setItem('expiresAt',  credentials.expiresAt);
    localStorage.setItem('firstToSelectPage',  credentials.firstToSelectPage);
  }
};

export const deleteCredentials = () => {
    localStorage.removeItem('token',);
    localStorage.removeItem('firstName');
    localStorage.removeItem('lastName');
    localStorage.removeItem('accounts');
    localStorage.removeItem('currentAccountIndex');
    localStorage.removeItem('firstToSelectPage');
    localStorage.removeItem('expiresAt');
};

export const getCredentials = () => {
  const {token, firstName, lastName, accounts, currentAccountIndex, expiresAt, firstToSelectPage} = localStorage;
  if (
    token !== undefined &&
    firstName !== undefined &&
    lastName !== undefined &&
    accounts !== undefined
  ) {
    return {
      token,
      firstName,
      lastName,
      accounts,
      currentAccountIndex,
      firstToSelectPage,
      credentialsPresent: true,
      expiresAt
    }
  }
  return {
    credentialsPresent: false,
  }
};
